import AddIcon from '@mui/icons-material/Add';
import { Button, Stack, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { cloneDeep, concat, get, set } from 'lodash';
import React, { FC } from 'react';
import { checkIfHasComment } from 'src/pages/private/online-antrag/application-helper-function/PruefAssistenzHelperFunktion';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import MUIAccordionComponent from '../../../../../../../components/ui-component/mui-accordion/MUIAccordionComponent';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import DeleteRecord from '../../../../../../../lib/api/DeleteRecord';
import { APIS } from '../../../../../../../lib/constants/apis';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, KOSTEN_ARTEN, PRUEF_ASSISTENZ_STATUS } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import { ForceTrue, NonRequired, ValidDate } from '../../../../../../../lib/validation/ValidationTypes';
import { DisplayEuro } from '../../../../../../../utils/formats';
import { addIndexesToPath, isTrue } from '../../../../../../../utils/helper';
import PruefAssistenz from '../../../../antrag-components/PruefAssistenz';

// import schemas
import KostenPositionSchema from '../../../../../../../lib/paths/kostenposition_FULL_Paths.json';
import MitelabrufSchema from '../../../../../../../lib/paths/mittelabruf_FULL_Paths.json';
import NachweisPositionSchema from '../../../../../../../lib/paths/nachweisposition_FULL_Paths.json';
const MA_P = MitelabrufSchema.attributes;
const KP_P = KostenPositionSchema.attributes;
const NP_P = NachweisPositionSchema.attributes;

const InvestitionsKostenMA: FC<{ kostentraeger: string; unternehmenId: number }> = ({ kostentraeger, unternehmenId }) => {
	const { application, setApplicationProperty, saveApplication, readOnly } = useApplication();

	const getkostenPositionTitle = (eachPosition_OBJ: any, kostenPositionID: number) => {
		const allNachweisPositions = get(application, MA_P.Mittelabruf_Nachweispositions.path, []);
		const summe = allNachweisPositions
			.filter((ele: any) => get(ele, `${NP_P.Allgemein_Kostenposition.path}.id`) === kostenPositionID)
			.reduce((sum: any, item: any) => sum + get(item, NP_P.Allgemein_Ausgaben_Kosten.path, 0), 0);
		return `${get(eachPosition_OBJ, KP_P.Allgemein_Kostenkategorie.schema.attributes.Allgemein_Bezeichnung.path, '')} - Gesamtsumme: ${DisplayEuro(summe)}`;
	};
	const isSelectedNachweisReadOnly = (nachweisObj: any) => {
		if (get(nachweisObj, NP_P.Pruefung_Pruefstatus.path) === PRUEF_ASSISTENZ_STATUS.freigegeben) {
			return true;
		} else {
			return readOnly;
		}
	};

	const handleAddNachweisPosition = async (currKostenPosition: any) => {
		let appCopy = cloneDeep(application);
		let newNachweisPostionData = {
			Allgemein_Nr: get(appCopy, MA_P.Mittelabruf_Nachweispositions.path, []).length + 1,
			Mittelabruf: get(appCopy, `id`),
			Allgemein_Kostenposition: get(currKostenPosition, 'id'),
			Allgemein_Kostenart: get(currKostenPosition, KP_P.Allgemein_Kostenposition.path),
			Allgemein_Kostentraeger: get(currKostenPosition, KP_P.Allgemein_Kostentraeger.path),
			Allgemein_Unternehmen_Institution: get(currKostenPosition, `${KP_P.Unternehmen.path}.id`),
			Allgemein_Bezeichnung: get(currKostenPosition, KP_P.Allgemein_Bezeichnung.path),
			Kostennachweise_Nachweise: [{ Kommentar: '' }],
		};
		set(
			appCopy,
			`${MA_P.Mittelabruf_Nachweispositions.path}.${get(application, MA_P.Mittelabruf_Nachweispositions.path, []).length}.attributes`,
			newNachweisPostionData,
		);

		saveApplication(false, appCopy);
	};

	const handleDeleteNachweis = async (id: number) => {
		try {
			let appCopy = cloneDeep(application);
			const allNachweisPosition = get(appCopy, MA_P.Mittelabruf_Nachweispositions.path, []);

			set(
				appCopy,
				MA_P.Mittelabruf_Nachweispositions.path,
				allNachweisPosition.filter((ele: any) => ele.id !== id),
			);
			const res = await DeleteRecord(APIS.Nachweisposition, id);
			if (res) saveApplication(false, appCopy);
		} catch (err: any) {
			console.error('ERROR: Deleting Nachweisposition ', err);
		}
	};

	return (
		<>
			{get(application, MA_P.Foerderantrag.schema.attributes.Foerderantrag_Kostenpositions.path, []).map(
				// eslint-disable-next-line array-callback-return
				(eachKostenPosition: any, i: number) => {
					if (
						get(eachKostenPosition, KP_P.Allgemein_Kostentraeger.path) === kostentraeger &&
						get(eachKostenPosition, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Investitionskosten &&
						get(eachKostenPosition, `${KP_P.Unternehmen.path}.id`) === unternehmenId
					) {
						return (
							<React.Fragment key={i}>
								<Stack direction={'row'} justifyContent={'space-between'} alignItems={'flex-end'} sx={{ mt: '2rem' }}>
									<Typography variant='h5'>{getkostenPositionTitle(eachKostenPosition, get(eachKostenPosition, 'id'))}</Typography>
									<Button endIcon={<AddIcon />} disabled={readOnly} onClick={() => handleAddNachweisPosition(eachKostenPosition)}>
										Position hinzufügen
									</Button>
								</Stack>

								{/* eslint-disable-next-line array-callback-return */}
								{get(application, MA_P.Mittelabruf_Nachweispositions.path, []).map((eachNachweis: any, nachweisIndex: number) => {
									if (get(eachNachweis, `${NP_P.Allgemein_Kostenposition.path}.id`) === get(eachKostenPosition, 'id')) {
										return (
											<MUIAccordionComponent
												key={i + nachweisIndex}
												summaryTitle={`${get(eachNachweis, NP_P.Allgemein_Bezeichnung.path, '')} ${' - '} Summe: ${DisplayEuro(get(eachNachweis, NP_P.Allgemein_Ausgaben_Kosten.path, 0))}`}
												onDelete={() => handleDeleteNachweis(get(eachNachweis, 'id'))}
												hasComment={isTrue(
													checkIfHasComment(
														readOnly,
														application,
														addIndexesToPath(
															MA_P.Mittelabruf_Nachweispositions.schema.attributes.Pruefung_Hinweis_Fuer_Den_Antragsteller.path,
															[`${nachweisIndex}`],
															['Mittelabruf_Nachweispositions'],
														),
													),
												)}
											>
												<PruefAssistenz
													statusPath={addIndexesToPath(
														MA_P.Mittelabruf_Nachweispositions.schema.attributes.Pruefung_Pruefstatus.path,
														[`${nachweisIndex}`],
														['Mittelabruf_Nachweispositions'],
													)}
													hinweisPath={addIndexesToPath(
														MA_P.Mittelabruf_Nachweispositions.schema.attributes.Pruefung_Hinweis_Fuer_Den_Antragsteller.path,
														[`${nachweisIndex}`],
														['Mittelabruf_Nachweispositions'],
													)}
													ueberarbeitetAmPath={addIndexesToPath(
														MA_P.Mittelabruf_Nachweispositions.schema.attributes.Pruefung_Ueberarbeitet_Am.path,
														[`${nachweisIndex}`],
														['Mittelabruf_Nachweispositions'],
													)}
													erledigtPath={addIndexesToPath(
														MA_P.Mittelabruf_Nachweispositions.schema.attributes.Pruefung_Erledigt.path,
														[`${nachweisIndex}`],
														['Mittelabruf_Nachweispositions'],
													)}
													formStruc={mapFormStruc(PruefAssistenzStruc(), nachweisIndex)}
												/>

												<Grid2 spacing={6} container>
													<Grid2 sm={6}>
														<CreateForm
															formStruc={mapFormStruc(formStrucNachweis(application, nachweisIndex), nachweisIndex)}
															formValues={application}
															updateFormValuesFunc={setApplicationProperty}
															readOnly={isSelectedNachweisReadOnly(eachNachweis)}
															api={APIS.Nachweisposition}
														/>
													</Grid2>
													<Grid2 sm={6}>
														<CreateForm
															formStruc={mapFormStruc(formStrucNachweisSpalte2(), nachweisIndex)}
															formValues={application}
															updateFormValuesFunc={setApplicationProperty}
															readOnly={isSelectedNachweisReadOnly(eachNachweis)}
															api={APIS.Nachweisposition}
														/>
													</Grid2>
												</Grid2>
											</MUIAccordionComponent>
										);
									}
								})}
							</React.Fragment>
						);
					}
				},
			)}
		</>
	);
};
export default InvestitionsKostenMA;

const PruefAssistenzStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...MA_P.Mittelabruf_Nachweispositions.schema.attributes.Pruefung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStrucNachweis = (application: any, nachweisIndex: number) => {
	const isAbschreibungFaehigeKategorie = get(
		application,
		addIndexesToPath(
			MA_P.Mittelabruf_Nachweispositions.schema.attributes.Allgemein_Kostenposition.schema.attributes.Allgemein_Kostenkategorie.schema.attributes
				.Allgemein_Abschreibungsfaehig.path,
			[`${nachweisIndex}`],
			['Verwendungsnachweis_Nachweispositions'],
		),
	);
	const isNachweisAbschreibungFaehig = get(
		application,
		addIndexesToPath(
			MA_P.Mittelabruf_Nachweispositions.schema.attributes.Beleg_Af_A_Absetzung_Fuer_Abnutzungen_Abschreibungsfaehig.path,
			[`${nachweisIndex}`],
			['Verwendungsnachweis_Nachweispositions'],
		),
	);
	let struc: FormStrucItem[] = [
		{
			fields: [MA_P.Mittelabruf_Nachweispositions.schema.attributes.Allgemein_Bezeichnung],
			userProps: { columnToDivide: 1 },
		},
		{
			fields: [
				{
					...MA_P.Mittelabruf_Nachweispositions.schema.attributes.Allgemein_Datum_Der_Rechnung,
					validation: [{ validateFunction: ValidDate, onlyValidateOnNonEmptyValue: true }],
				},
				{
					...MA_P.Mittelabruf_Nachweispositions.schema.attributes.Allgemein_Datum_Der_Zahlung,
					validation: [{ validateFunction: ValidDate, onlyValidateOnNonEmptyValue: true }],
				},
			],
		},
	];
	// Wenn ausgewählte KostenKategorie in Nachweisposition > KostenPostion > Kostenkategorie abschreibungfähig ist, dann soll die Checkbox erscheinen
	if (isAbschreibungFaehigeKategorie) {
		struc.push({
			fields: [MA_P.Mittelabruf_Nachweispositions.schema.attributes.Beleg_Af_A_Absetzung_Fuer_Abnutzungen_Abschreibungsfaehig],
		});
	}
	// If Nachweis Abschreibungsfähig dann Zusätzliche Felder auch anzeigen.
	if (isTrue(isNachweisAbschreibungFaehig)) {
		// BElege AFA
		struc.push(
			{
				fields: [
					MA_P.Mittelabruf_Nachweispositions.schema.attributes.Beleg_Af_A_Absetzung_Fuer_Abnutzungen_Datum_Der_Anschaffung,
					{
						...MA_P.Mittelabruf_Nachweispositions.schema.attributes.Beleg_Af_A_Absetzung_Fuer_Abnutzungen_Investition,
						format: 'currency',
					},
				],
				userProps: { columnToDivide: 1 },
			},
			{
				fields: [
					MA_P.Mittelabruf_Nachweispositions.schema.attributes.Beleg_Af_A_Absetzung_Fuer_Abnutzungen_Abschreibungsmonate,
					{
						...MA_P.Mittelabruf_Nachweispositions.schema.attributes.Beleg_Af_A_Absetzung_Fue_0114037618_m_Betrachteten_Haushaltsjahr,
						// format: 'currency',
					},
				],
			},
			{
				fields: [
					MA_P.Mittelabruf_Nachweispositions.schema.attributes.Beleg_Af_A_Absetzung_Fue_0188964903_ezogeneggf_Anteilige_Nutzung,
					{
						...MA_P.Mittelabruf_Nachweispositions.schema.attributes.Beleg_Af_A_Absetzung_Fue_0246879351_etzbarer_Abschreibungsbetrag,
						format: 'currency',
						disabled: true,
					},
				],
			},
		);
	} else {
		struc.push({
			fields: [
				{
					...MA_P.Mittelabruf_Nachweispositions.schema.attributes.Allgemein_Ausgaben_Kosten,
					format: 'currency',
				},
			],
			userProps: { columnToDivide: 1 },
		});
	}
	return struc;
};
const formStrucNachweisSpalte2 = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...MA_P.Mittelabruf_Nachweispositions.schema.attributes.Allgemein_Grund_Der_Zahlung_Erlaeuterung,
					validation: [{ validateFunction: NonRequired }],
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

const mapFormStruc = (formStruc: any[], index: number) => {
	let result = formStruc.map((row) => {
		return {
			...row,
			fields: (get(row, 'fields', []) as Array<any>).map((value) => {
				let pathWithoutIndex = get(value, 'path', '') as string;
				return {
					...value,
					path:
						pathWithoutIndex.slice(0, MA_P.Mittelabruf_Nachweispositions.path.length) +
						`.${index}` +
						pathWithoutIndex.slice(MA_P.Mittelabruf_Nachweispositions.path.length),
				};
			}),
		};
	});
	return result;
};
export const getFormStrucInvestitionsKostenMA = (application: any, kostentraeger: string, unternehmenId: number, _readOnly: boolean) => {
	let result: FormStrucItem[] = [];
	get(application, MA_P.Foerderantrag.schema.attributes.Foerderantrag_Kostenpositions.path, []).forEach((eachKostenPosition: any) => {
		if (
			get(eachKostenPosition, KP_P.Allgemein_Kostentraeger.path) === kostentraeger &&
			get(eachKostenPosition, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Investitionskosten &&
			get(eachKostenPosition, `${KP_P.Unternehmen.path}.id`) === unternehmenId
		) {
			const allNachweisPositions = get(application, MA_P.Mittelabruf_Nachweispositions.path, []);

			allNachweisPositions.forEach((eachNachweis: any, nachweisIndex: number) => {
				if (get(eachNachweis, `${NP_P.Allgemein_Kostenposition.path}.id`) === get(eachKostenPosition, 'id')) {
					const isHinweisFieldRequired =
						get(eachNachweis, NP_P.Pruefung_Hinweis_Fuer_Den_Antragsteller.path) && !isTrue(get(eachNachweis, NP_P.Pruefung_Erledigt.path));

					const PruefAssistenzStrucWithIndex = mapFormStruc(PruefAssistenzStruc(), nachweisIndex);
					const formStrucNachweisWithIndex = mapFormStruc(formStrucNachweis(application, nachweisIndex), nachweisIndex);
					const formStrucNachweisSpalte2WithIndex = mapFormStruc(formStrucNachweisSpalte2(), nachweisIndex);

					if (isHinweisFieldRequired)
						result = concat(result, PruefAssistenzStrucWithIndex, formStrucNachweisWithIndex, formStrucNachweisSpalte2WithIndex);
					else result = concat(result, formStrucNachweisWithIndex, formStrucNachweisSpalte2WithIndex);
				}
			});
		}
	});
	return result;
};
